import { handleActions } from 'redux-actions';

import fetchCurrentOrderSuccess from '../actions/fetchCurrentOrderSuccess';
import fetchCurrentOrderError from '../actions/fetchCurrentOrderError';

import handleFetchCurrentOrderError from './handleFetchCurrentOrderError';
import handleFetchCurrentOrderSuccess from './handleFetchCurrentOrderSuccess';

export default handleActions(
    {
        [fetchCurrentOrderSuccess]: handleFetchCurrentOrderSuccess,
        [fetchCurrentOrderError]: handleFetchCurrentOrderError,
    },
    {
        order: null,
        error: null,
    },
);
